export const withBotBGrid = <P extends {}>(WrappedComponent: React.ComponentType<P>) => {
  const ReturnComponent = (props: any) => {
    const renderRow = (row: any, sectionIndex: number, rowIndex: number) => {
      return (
        <div className="row clearfix">
          {row.areas.map((area: any, areaIndex: number) => (
            <div key={`${sectionIndex}${rowIndex}${areaIndex}`} className={`col-md-${area.grid} column`}>
              <WrappedComponent controls={area.controls} {...props} />
            </div>
          ))}
        </div>
      );
    };

    return (
      <div className="umbGrid">
        {props.botbGridContent?.sections?.map((section: any, sectionIndex: number) => (
          <div key={sectionIndex} className="gridSection">
            {section.rows.map((row: any, rowIndex: number) => (
              <section key={`${sectionIndex}${rowIndex}`} className="mx-auto mt-6 lg:mt-10 mainSection">
                {renderRow(row, sectionIndex, rowIndex)}
              </section>
            ))}
          </div>
        ))}
      </div>
    );
  };
  return ReturnComponent;
};
